export default __webpack_public_path__ + "images/f253729c2acd6b4c2d3e8383cb68a9cf.svg";